import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { ProConfigProvider, ProLayout } from "@ant-design/pro-components";
import { ConfigProvider, theme } from "antd";
import React, { useContext, useEffect, useRef } from "react";
import PanesContainer from "./components/PanesContainer";
import LayoutTabs from "./components/Tabs";
import MicroAppContainer from "./components/MicroAppContainer";
import LayoutContentWrapper from "./components/LayoutContentWrapper";
import { useLayoutInit } from "./hooks/useLayoutInit";
import { useProLayoutProps } from "./hooks/useProLayoutProps";
import { useScrollCache } from "./hooks/useScrollCache";
import PanesTransition from "./components/PanesTransition";
import { useAppStore, useMicroAppStore } from "../store";
import { getDisplayHiddenStyle } from "../utils";
import { ThemeProvider } from "styled-components";
import { isEmpty } from "lodash-es";
import { StylizedTheme } from "../theme/stylize";
import { GlobalStyle } from "../theme/global";
import FooterSection from "../components/FooterSection";
import microApp from "@micro-zoe/micro-app";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MainLayout = function MainLayout(props) {
  var _props$layoutConfig;
  var paneContainerRef = useRef(null);
  var _useContext = useContext(ConfigProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls();
  var initMicroApps = useMicroAppStore(function (s) {
    return s.initMicroApps;
  });
  var appData = props.appData;
  var microAppActivated = useMicroAppStore(function (s) {
    return s.microApps.some(function (el) {
      return el.activated;
    });
  });
  var flatPathMenus = useAppStore(function (s) {
    return s.flatPathMenus;
  });
  var menuInit = !isEmpty(flatPathMenus);

  // 框架初始化
  useLayoutInit(props);

  // proLayout设置
  var proLayoutProps = useProLayoutProps(props, props.proLayoutConfig);

  // 滚动条缓存
  useScrollCache(paneContainerRef);
  var mainPageContentStyle = getDisplayHiddenStyle(microAppActivated);
  var subAppPageContentStyle = getDisplayHiddenStyle(!microAppActivated);
  var themeToken = theme.useToken().token;
  var composeTheme = {
    prefixCls: prefixCls,
    proLayout: proLayoutProps.token,
    token: themeToken,
    tabsMode: (_props$layoutConfig = props.layoutConfig) === null || _props$layoutConfig === void 0 ? void 0 : _props$layoutConfig.tabsMode
  };
  useEffect(function () {
    return function () {
      microApp.unmountAllApps({
        destroy: true
      }).then(function () {
        return initMicroApps();
      });
    };
  }, []);
  return /*#__PURE__*/_jsx(ProConfigProvider, {
    token: composeTheme.proLayout,
    children: /*#__PURE__*/_jsxs(ThemeProvider, {
      theme: composeTheme,
      children: [/*#__PURE__*/_jsx(GlobalStyle, {}), /*#__PURE__*/_jsx(StylizedTheme, {}), /*#__PURE__*/_jsx(ProLayout, _objectSpread(_objectSpread({}, proLayoutProps), {}, {
        children: menuInit || props.layoutConfig.allowEmptyMenus ? /*#__PURE__*/_jsxs(LayoutContentWrapper, {
          children: [/*#__PURE__*/_jsx(LayoutTabs, _objectSpread({}, props)), /*#__PURE__*/_jsx(PanesTransition, {
            children: /*#__PURE__*/_jsxs("div", {
              className: "sa-main-content",
              ref: paneContainerRef,
              children: [/*#__PURE__*/_jsxs("div", {
                className: "sa-page-wrapper",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "sa-page-content",
                  style: mainPageContentStyle,
                  children: /*#__PURE__*/_jsx(PanesContainer, {
                    appData: appData,
                    layoutConfig: props.layoutConfig
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "sa-page-content sa-sub-app-hook",
                  style: subAppPageContentStyle,
                  children: /*#__PURE__*/_jsx(MicroAppContainer, {
                    layoutConfig: props.layoutConfig
                  })
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: "sa-footer-container",
                children: /*#__PURE__*/_jsx(FooterSection, {
                  renderFooter: props.layoutConfig.renderFooter
                })
              })]
            })
          })]
        }) : null
      }))]
    })
  });
};
export default MainLayout;